import { getURLParam } from '../adapters/dupes/queryParams.js';


const DEFAULT_PER_PAGE = 10;
const DEFAULT_PAGE = 1;

const UTM_PARAMS = [
    'utm_campaign',
    'utm_medium',
    'utm_source',
    'utm_content',
    'utm_term',
];
const REFERRAL_PARAMS = ['rf', 'referralCode'];
export const TRACKING_PARAMS = UTM_PARAMS.concat(REFERRAL_PARAMS);

export const getPage = function (url) {
    return parseInt(getURLParam(url, 'page') || DEFAULT_PAGE, 0);
};

export const getIndex = function (url, perPage = DEFAULT_PER_PAGE) {
    const page = getPage(url);
    return (page - 1) * perPage;
};
